import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import _get from 'lodash/get';
import ConfirmButton from '../confirm-button';
import { makeCityPrimaryMutation } from '../../apollo/cities';
import { useAppContext } from '../../contexts/app';

const CityPrimaryToggle = ({ city }) => {
  const { loggedInUser } = useAppContext();
  const [makeCityPrimary] = useMutation(makeCityPrimaryMutation);

  const handleClick = useCallback((e) => {
    e.preventDefault();
    makeCityPrimary({
      variables: { id: city.id }
    });
  }, [city]);

  if (!loggedInUser) {
    return null;
  }

  if (city.id === _get(loggedInUser, 'primaryCity.id')) {
    return null;
  }

  return (
    <ConfirmButton
      label="Switch To City"
      confirmMessage={`Are you sure you want to change your primary city to ${city.name}?`}
      variant="outlined"
      color="primary"
      onClick={handleClick}
    />
  );
};

CityPrimaryToggle.propTypes = {
  city: PropTypes.object,
  makeCityPrimary: PropTypes.func,
  loggedInUser: PropTypes.object,
};

export default CityPrimaryToggle;